// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"notification-general-settings_checkboxWrapper__1apWX"};